export default [
  {
    key: 'tax',
    label: 'field.tax',
    rules: 'required|decimal:2|max_value:100',
    type: 'currency',
    suffix: '%'
  },
  {
    key: 'maxTotalBet',
    label: 'field.maxTotalBet',
    rules: 'required|decimal:2',
    type: 'currency',
  },
]
